import createParseMiddleware from './createParseMiddleware';
import { parseAuth } from 'utils/apiParser/authParser';
import { Auth } from 'types/authTypes';

export const parseLoginMiddleware = createParseMiddleware<Auth>(parseAuth, 'auth/login');
